



































































import { getWheelOfFortuneList, getAllTypePop, createAbtestPop } from "@/services/api";
import { dateFormat } from "@/services/common";
import { Message } from "element-ui";
import { Component, Vue, Prop ,Watch } from "vue-property-decorator";


@Component({})
export default class ABTestAddOldDialog extends Vue {
  @Prop()
  visible!:boolean;

  @Prop()
  abTestDetail?:any;

  @Watch('abTestDetail')
  getAbtestData() {
    if (this.abTestDetail && this.abTestDetail.triggerEventType !== undefined) {
      getAllTypePop({
        triggerEventType:this.abTestDetail.triggerEventType,
      }).then((res) => {
        this.tableData = res.data.data;
        if (this.tableData.length > 0) {
          this.choose = this.tableData[0].id;
        }
      });
    }
  }

  choose = '';

  tableData:any[] = [];

  apiLoading = false;
  public date = [dateFormat('YYYY-mm-dd 00:00:00', new Date()), dateFormat('YYYY-mm-dd 00:00:00', new Date())]

  handleClose() {
    if (this.tableData.length > 0) {
      this.choose = this.tableData[0].id;
    } else {
      this.choose = '';
    }
    this.$emit('update:visible', false);
    this.apiLoading = false;
  }

  // mounted() {
  //   getAllTypePop({
  //     triggerEventType:this.abTestDetail.triggerEventType,
  //   }).then((res) => {
  //     this.tableData = res.data.data;
  //     if (this.tableData.length > 0) {
  //       this.choose = this.tableData[0].id;
  //     }
  //   });
  // }

  checkItem(row:any) {
    if (row.type == 1) {
      window.open(`/wheel_of_fortune/setting/${row.id}?abtest=true&abtestid=${this.abTestDetail.id}`)
    }else if(row.type == 2){
      window.open(`/wheel_of_fortune/pop/${row.id}?abtest=true&abtestid=${this.abTestDetail.id}`)
    }
  }

  createAbtestPop() {
    if (!!this.choose) {
      this.apiLoading = true;
      // 请求完成
      createAbtestPop({
        mainFormId: this.abTestDetail.id,
        historyFormId: this.choose,
      }).then((res) => {
        if (this.tableData.length > 0) {
          this.choose = this.tableData[0].id;
        } else {
          this.choose = '';
        }
        this.$emit('changeDetail');
        this.$emit('update:visible', false);
        this.apiLoading = false;
        Message.success(this.$tx('settings.page.addedSuccessfully', '添加成功'));
      }).catch(() => {
        this.apiLoading = false;
      });
    } else {
      Message.error(this.$tx('form.pleaseSelectSignUpForm', '请选择订阅工具'));
    }
  }
}
